import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { map } from 'lodash';

/**
 * Component for breadcrumbs. The breadcrumbds are rendered as a `<ul>` with each breadcrumb as a `<li>`.
 * The entire `ul` has the `ph-breadcrumbs` class name and each `<li>` has the `ph-breadcrumb` class name.
 *
 * **Base CSS Class:** `ph-breadcrumbs`
 */

export default function CoreBreadcrumbs({ className, children }) {
	return (
		<ul className={classnames('ph-new-breadcrumbs', className)}>
			{map(children, (crumb, index) => {
				const key = crumb.key ? `${crumb.key} ${index}` : index;

				return (
					<li className="ph-new-breadcrumb" key={key}>
						{crumb}
					</li>
				);
			})}
		</ul>
	);
}

CoreBreadcrumbs.propTypes = {
	/** Ordered list of breadcrumbs to be rendered */
	children: PropTypes.arrayOf(PropTypes.any),
	className: PropTypes.string
};
